/**********************************************
String Filters
**********************************************/

/**
 * @param {*} str
 */
 export function quote(str) {
  return str && str.length && ("“" + str.replace(/"“”/g, "") + "”");
}

/**
 * @param {*} str
 */
export function capitalize(str) {
  return str && str.length && (str.charAt(0).toUpperCase() + str.slice(1));
}

/**
 * @param {*} str
 */
export function lowercase(str) {
  return str && str.toLowerCase();
}

/**
 * @param {*} str
 */
export function camelCase(str) {
  return str && str.toLowerCase()
    .replace( /[-_]+/g, " ")
    .replace( /[^\w\s]/g, "")
    .replace( / (.)/g, function($1) { return $1.toUpperCase(); })
    .replace( / /g, "" );
}

/**
 * @param {*} str
 */
export function handleize(str) {
  return str && str.toLowerCase()
    .replace(/\W+/g, "-")
    .replace( /[^\w\s]/g, "-")
    .replace( / /g, "" );
}

/**
 * @param {*} str
 */
export function capitalizeAll(str) {
  return str && (str.split(" ").map(str => str && str.length && str.charAt(0).toUpperCase() + str.slice(1))).join(" ");
}

/**
 * @param {*} str
 */
 export function splitWords(str) {
  return str && typeof str === "string" && str.split(/\s/);
}

/**
 * @param {*} str
 */
export function aspectRatio(str) {
  const ratio = str.split(":")
    .map(s => parseInt(s));
  return ratio[1] / ratio[0] * 100;
}

/**
 *
 * @param {*} str
 * @returns {boolean}
 */
export function isValidEmail(str) {
  return String(str).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}

/**********************************************
Helpers
**********************************************/

// /**
//  * Intersection Observer API
//  * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
//  */
//  export function getIntersectionObserverSupport() {
//   const needs_polyfill = !("IntersectionObserver" in window) ||
//   !("IntersectionObserverEntry" in window) ||
//   !("intersectionRatio" in window.IntersectionObserverEntry.prototype);
//   return !needs_polyfill;
// }

// export function polyfillIntersectionObserverIfNecessary() {
//   const supports_io = getIntersectionObserverSupport();

//   let io_load_promise;
//   if(supports_io) {
//     io_load_promise = Promise.resolve();
//   }
//   else {
//     io_load_promise = import("intersection-observer");
//   }
//   return io_load_promise;
// }

/**
 * Page visibility API
 * https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
 */
export function getVisibilityApiSupport() {
  let document_hidden_property_name = undefined;
  let visibility_change_function_name = undefined;

  //
  if (typeof document.hidden !== "undefined") {
    document_hidden_property_name   = "hidden";
    visibility_change_function_name = "visibilitychange";
  }
  //
  else if (typeof document.msHidden !== "undefined") {
    document_hidden_property_name   = "msHidden";
    visibility_change_function_name = "msvisibilitychange";
  }
  //
  else if (typeof document.webkitHidden !== "undefined") {
    document_hidden_property_name = "webkitHidden";
    visibility_change_function_name = "webkitvisibilitychange";
  }

  return {
    is_supported: document_hidden_property_name !== undefined,
    document_hidden_property_name,
    visibility_change_function_name
  };
}

/**
 * Detect if "event passive" is supported
 */
let supports_passive = false;
try {
  window.addEventListener("test", null,
    Object.defineProperty(
      {},
      "passive",
      {
        /* eslint-disable-next-line getter-return */
        get: function() { supports_passive = { passive: true }; }
      }
    )
  );
  /* eslint-disable-next-line no-empty */
} catch(err) {}
export const passiveIfSupported = supports_passive;

/**
 *
 * @param {*} object JS Object
 */
export function objectToUrlParams(object) {
  const params = new URLSearchParams();
  if(typeof object !== "undefined") {
    for (const [key, value] of Object.entries(object)) {
      params.set(key, value);
    }
  }
  return params;
}

/**********************************************
Math / Data Manipulation
**********************************************/

/**
* https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
* Shuffles array in place. ES6 version
* @param {Array} a items An array containing the items.
*/
export function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/**
 *
 * @param {*} min
 * @param {*} max
 * @returns
 */
export function ranRange(min, max) {
  return Math.floor(Math.random()*(max-min) + min);
}

/**
 *
 * @param {*} arr
 * @returns
 */
export function ranItem(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

/**
 *
 * Linear Interpolation
 * https://github.com/mattdesl/lerp
 */
export function lerp(a, b, n) {
  return (1 - n) * a + n * b;
}

/**
 *
 * Easing Functions
 * https://gist.github.com/gre/1650294
 */
// no easing, no acceleration
export function linear(t) { return t; }
// accelerating from zero velocity
export function easeInQuad(t) { return t * t; }
// decelerating to zero velocity
export function easeOutQuad(t) { return t * (2 - t); }
// acceleration until halfway, then deceleration
export function easeInOutQuad(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
// accelerating from zero velocity
export function easeInCubic(t) { return t * t * t; }
// decelerating to zero velocity
export function easeOutCubic(t) { return (--t) * t * t + 1; }
// acceleration until halfway, then deceleration
export function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; }
// accelerating from zero velocity
export function easeInQuart(t) { return t * t * t * t; }
// decelerating to zero velocity
export function easeOutQuart(t) { return 1 - (--t) * t * t * t; }
// acceleration until halfway, then deceleration
export function easeInOutQuart(t) { return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; }
// accelerating from zero velocity
export function easeInQuint(t) { return t * t * t * t * t; }
// decelerating to zero velocity
export function easeOutQuint(t) { return 1 + (--t) * t * t * t * t; }


/**********************************************
Image Loading
**********************************************/

/**
 *
 * Promisify Image Loading
 * https://stackoverflow.com/questions/52059596/loading-an-image-on-web-browser-using-promise
 */
export const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.addEventListener("load", () => resolve(img));
  img.addEventListener("error", (err) => reject(err));
  img.src = src;
});

/**
 *
 * Promisify Image Loading
 * https://stackoverflow.com/questions/52059596/loading-an-image-on-web-browser-using-promise
 */
export const watchImageLoad = (img) => {
  return new Promise((resolve, reject) => {
    const resolve_fn = () => resolve(img);
    const reject_fn = err => reject(err);

    if (img) {
      if(img.tagName === "PICTURE") img = img.querySelector("img");
      if(img.complete) resolve(img);
      img.addEventListener("load", resolve_fn);
      img.addEventListener("error", reject_fn);
      // TODO: Remove these listeners somehow
    }
  });
};

/**********************************************
Video Loading
**********************************************/

/**
 *
 * @param {*} vimeo_id
 * @returns Promise
 */
export function getVimeoOembedMetadata(vimeo_id) {
  const vimeo_metadata_endpoint = `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${vimeo_id}`;
  return fetch(vimeo_metadata_endpoint).then(res => {
    if(!res.ok) {
      throw new Error(`Fetching video metadata failed for ${vimeo_id}`);
    }
    return res.json();
  });
}
